import React from "react";
import { ReactComponent as Edit } from "../../assets/icons/edit.svg";
import { useCustomTranslation } from "@/hooks/useTranslation";
import { hoveredStepNumber } from "./ShowOriginal";
import { useGlobalStore } from "@/store";

export const ShowContModification = ({ setToggle, showContModification }) => {
  const { setStepperControls } = useGlobalStore(state => ({
    setStepperControls: state.setStepperControls,
  }));
  const { content } = useCustomTranslation();

  const getContent = (group, key) => {
    return content(`controls.${group}.${key}`);
  };

  const handleClick = () => {
    setToggle("showContModification", !showContModification);
    setStepperControls("currentStep", hoveredStepNumber);
    setStepperControls("storedStep", hoveredStepNumber);
  };

  return (
    <button
      onClick={handleClick}
      className="mb-2 grid w-[258px] grid-cols-[1fr,auto] rounded border-2 border-solid border-[#009ACE] bg-white px-4 py-4 text-[#009ACE]"
    >
      <div className="text-start text-base font-medium">
        {getContent("actions", "continue_modifications")}{" "}
      </div>
      <Edit />
    </button>
  );
};
